import { useState } from "react";
import ContentPreviewContext from "../../content/ContentPreviewContext";
import { CabinetContentProvider } from "../../content/CabinetContentContext";
import { DOCUMENT_IDS, DOCUMENT_LABELS, getPath } from "../../content/cabinetSchema";
import SafeHtml from "../../content/SafeHtml";
import BlockReader from "../userCabinet/blockReader";
import BlockLibrarian from "../userCabinet/BlockLibrarian";
import BlockMaister from "../userCabinet/blockMaister";
import BlockBusiness from "../userCabinet/blockBusiness";
import s from "./UserCabinetEditor.module.css";
const ROLES = {
  blockReader: "club",
  blockLibrarian: "librarian",
  blockMaister: "maister",
  blockBusiness: "business"
};
const BLOCKS = {
  blockReader: BlockReader,
  blockLibrarian: BlockLibrarian,
  blockMaister: BlockMaister,
  blockBusiness: BlockBusiness
};
export default function CabinetPreview({
  models,
  activeDoc
}) {
  const [role, setRole] = useState(activeDoc === "userCabinet" ? "blockReader" : activeDoc);
  const [mobile, setMobile] = useState(false);
  const Block = BLOCKS[role];
  const user = models.userCabinet;
  const context = Object.fromEntries(DOCUMENT_IDS.map(id => [`siteContent/${id}`, models[id]]));
  return <>
    <div className={s.toolbar}>
      <label>Кабінет <select aria-label="Кабінет для попереднього перегляду" value={role} onChange={e => setRole(e.target.value)}>{Object.keys(ROLES).map(id => <option key={id} value={id}>{DOCUMENT_LABELS[id]}</option>)}</select></label>
      <label><input type="checkbox" checked={mobile} onChange={e => setMobile(e.target.checked)} /> Мобільний вигляд</label>
    </div>
    <div className={`${s.preview} ${mobile ? s.previewMobile : ""}`} onClickCapture={e => {
      if (e.target.closest("a")) e.preventDefault();
    }}>
      <ContentPreviewContext.Provider value={context}>
        <CabinetContentProvider value={user}>
          <div className={s.previewIntro}><p>{user.hero?.missionText}</p><p>{user.hero?.goalText}</p></div>
          <h3>{user.registration?.prefix} {DOCUMENT_LABELS[role]}</h3>
          <SafeHtml html={getPath(user, `registration.useShared.${ROLES[role]}`) ? user.registration?.descriptionHtml : getPath(user, `registration.byRole.${ROLES[role]}`)} />
          <div className={s.previewDiscount}>
            <h3>{role === "blockBusiness" ? user.messages?.cabinet?.text032 : role === "blockLibrarian" ? user.messages?.cabinet?.text025 : user.discount?.unsigned?.title}</h3>
            <p>{role === "blockBusiness" ? user.messages?.cabinet?.BUSINESS_NOTE : role === "blockLibrarian" ? user.messages?.cabinet?.LIBRARIAN_NOTE : user.discount?.unsigned?.subtitle}</p>
          </div>
          {Block && <Block userBd={{}} />}
        </CabinetContentProvider>
      </ContentPreviewContext.Provider>
    </div>
  </>;
}
